var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table",style:({
    width: ((_vm.len * 120) + "px") 
  })},[_c('tbody',_vm._l((_vm.getRow()),function(value,index){return _c('tr',{key:index,staticClass:"row"},_vm._l((_vm.getCell(value)),function(cell,i){return _c('td',{key:i,staticClass:"cell",domProps:{"innerHTML":_vm._s(_vm.convertLinkified(cell))}})}),0)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }